import { VarianceAnalysisData } from '@/api/workOrders/types';
import { Box, Grid, Typography } from '@mui/material';
import { memo } from 'react';

import { GroupStatusIcon } from '../../components/StatusIndicators';
import { isGroupComplete } from '../../utils/completionUtils';
import { INF_STATISTIC_FIELD_LABELS } from '../constants';

interface VarianceProps {
  variance: VarianceAnalysisData[];
}

export const VarianceAnalysis = memo(function VarianceAnalysis(
  props: VarianceProps
) {
  const { variance } = props;

  const isVarianceComplete =
    variance.length >= 3 &&
    isGroupComplete(
      variance[0].sum_of_squares,
      variance[0].degrees_of_freedom,
      variance[0].squares_mean,
      variance[0].f,
      variance[1].sum_of_squares,
      variance[1].degrees_of_freedom,
      variance[1].squares_mean,
      variance[2].sum_of_squares,
      variance[2].degrees_of_freedom
    );

  return (
    <Grid id="inf-variance" container spacing={2} marginBottom={3}>
      <Grid item xs={12}>
        <Box display="flex" alignItems="center" gap={1}>
          <GroupStatusIcon isComplete={isVarianceComplete} />
          <Typography my={2} fontWeight={600}>
            Análise da Variância de Regressão
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Typography mb={1} color="#707070">
          Explicada
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_STATISTIC_FIELD_LABELS.sum_of_squares}
        </Typography>
        <Typography>{variance[0]?.sum_of_squares ?? '-'}</Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_STATISTIC_FIELD_LABELS.degrees_of_freedom}
        </Typography>
        <Typography>{variance[0]?.degrees_of_freedom ?? '-'}</Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_STATISTIC_FIELD_LABELS.squares_mean}
        </Typography>
        <Typography>{variance[0]?.squares_mean ?? '-'}</Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_STATISTIC_FIELD_LABELS.variance_f}
        </Typography>
        <Typography>{variance[0]?.f ?? '-'}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography my={1} color="#707070">
          Não Explicada
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_STATISTIC_FIELD_LABELS.sum_of_squares}
        </Typography>
        <Typography>{variance[1]?.sum_of_squares ?? '-'}</Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_STATISTIC_FIELD_LABELS.degrees_of_freedom}
        </Typography>
        <Typography>{variance[1]?.degrees_of_freedom ?? '-'}</Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_STATISTIC_FIELD_LABELS.squares_mean}
        </Typography>
        <Typography>{variance[1]?.squares_mean ?? '-'}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography my={1} color="#707070">
          Total
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_STATISTIC_FIELD_LABELS.sum_of_squares}
        </Typography>
        <Typography>{variance[2]?.sum_of_squares ?? '-'}</Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_STATISTIC_FIELD_LABELS.degrees_of_freedom}
        </Typography>
        <Typography>{variance[2]?.degrees_of_freedom ?? '-'}</Typography>
      </Grid>
    </Grid>
  );
});
